import React from "react";
import styled from "styled-components";
import { Modal, Input } from "@arco-design/web-react";
import { isBlank, isValidEmail, emailFormatError } from "../../utils/validators";
import { isFreeMailAddress } from "../../utils/freeMail";

const FieldError = styled.div`
  font-size: 12px;
  color: rgb(var(--red-6));
  margin-top: 4px;
`;

// MUI -> Arco. Dialog(+Title/Content/Actions) -> Modal (visible/onOk/onCancel/
// title; Cancel/Save become okText/cancelText). MUI TextFields -> Arco Inputs
// with the label rendered above each field. Arco Input onChange passes the
// value, not an event. Unused Chip/Autocomplete imports were dropped.
// makeStyles -> styled-components; theme.spacing(1) = 8px.

const FieldLabel = styled.div`
  font-size: 12px;
  color: var(--color-text-3);
  margin-bottom: 4px;
`;

const Field = styled.div`
  margin-top: 8px;
`;

const FieldWarn = styled.div`
  font-size: 12px;
  color: rgb(var(--orange-6));
  margin-top: 6px;
`;

const FieldHint = styled.div`
  font-size: 12px;
  color: var(--color-text-3);
  margin-top: 4px;
`;

export default function SenderEmailAddEditDialog({ open, onSave, onClose, senderName, setSenderName, senderEmail, setSenderEmail, senderId, viaBrand }) {

  // console.log("SenderEmailAddEditDialog, senderName=", senderName, " senderEmail=", senderEmail, " senderId=", senderId);
  // const [open, setOpen] = React.useState(false);

  // const [name, setName] = React.useState(senderName || "");
  // const [email, setEmail] = React.useState(senderEmail || "");
  // const [id, setId] = React.useState(senderId || "");

  // React.useEffect(() => {
  //   setName(senderName);
  //   setEmail(senderEmail);
  //   setId(senderId);

  // }, [senderName, senderEmail, senderId])

  // const handleClickOpen = () => {
  //   setOpen(true);
  // }

  const handleClose = () => {
    onClose && onClose();
    // if (! (senderName && senderEmail && senderId)) {
    //   setName("");
    //   setEmail("");
    //   setId("");
    // }

    // setName(senderName);
    // setEmail(senderEmail);
    // setId(senderId);

    // setOpen(false);
  };

  const emailErr = emailFormatError(senderEmail);
  const isValid = !isBlank(senderName) && isValidEmail(senderEmail);

  const handleSave = () => {
    if (!isValid) {
      return;
    }
    // onSave && onSave({ "name": senderName, "email": senderEmail, "id": senderId });
    onSave && onSave();
    handleClose();
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSave();
    }

    return false;
  }


  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      onOk={handleSave}
      title={`${senderId != "" ? "Edit" : "Add"} Sender`}
      okText="Save"
      cancelText="Cancel"
      okButtonProps={{ disabled: !isValid }}
    >
      <Field>
        <FieldLabel>Name</FieldLabel>
        <Input
          autoFocus
          id="name"
          value={senderName}
          onChange={(v) => {
            setSenderName(v);
          }}
        />
      </Field>

      <Field>
        <FieldLabel>Email</FieldLabel>
        <Input
          id="email"
          value={senderEmail}
          error={!!emailErr}
          onChange={(v) => {
            setSenderEmail(v);
          }}
          onKeyDownCapture={handleKeyPress}
        />
        {emailErr && <FieldError>{emailErr}</FieldError>}
        <FieldHint>
          {senderId
            ? "Changing the address starts over: unless it's on your verified domain, it needs its confirmation emails clicked again."
            : "We'll send two confirmation emails to this address (one from us, one from Amazon). Both links need to be clicked. Addresses on a verified sending domain need none; if it's your own domain, we'll offer to set that up instead."}
        </FieldHint>
        {isFreeMailAddress(senderEmail) && (
          <FieldWarn>
            {viaBrand
              ? `Mail from Gmail, Yahoo and similar addresses lands in spam when sent directly, so it goes out as “${senderName || "you"} via ${viaBrand}”, with replies coming to you. Only our confirm link is needed. For the best results, send from your own domain.`
              : "Mail from Gmail, Yahoo and similar addresses sent through us usually lands in spam. For the best results, send from your own domain (add it under Sending Domains)."}
          </FieldWarn>
        )}
      </Field>
    </Modal>
  );
}
